module.exports = __webpack_public_path__ + "static/media/ic_send_to_internal.b28fe06b.svg";